import * as types from "./actionTypes";

const initialState = {
  specials: null,
  times: null,
  types: null,
  dates: null,
  options: null,
  reset: false,
  view: {
    map: false,
    list: true
  }
};

const specials = (state = initialState, action) => {
  switch (action.type) {
    case types.SPECIALS_GET:
      return {
        ...state,
        specials: action.data.response.data
      };

    case types.SPECIALS_FILTER_TYPES_GET:
      return {
        ...state,
        types: action.data.response.data
      };

    case types.SPECIALS_FILTER_DATES_GET:
      return {
        ...state,
        dates: action.data.response.data,
        times: action.data.response.times
      };

    case types.SPECIALS_FILTER_OPTIONS_GET:
      return {
        ...state,
        options: action.data.response.data
      };

    case types.SPECIALS_RESET:
      return {
        ...state,
        reset: !state.reset
      };

    case types.SPECIALS_CHANGE_VIEW:
      return {
        ...state,
        view: {
          map: !state.view.map,
          list: !state.view.list
        }
      };

    default:
      return state;
  }
};

export default specials;



// WEBPACK FOOTER //
// ./src/modules/specials/reducer.js